import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enGB from "./locales/en-GB.json";

/**
 * All user-facing text goes through i18n (arch §4.2). Not to support multiple
 * languages — the platform is single-locale `en-GB` (spec §18.5) — but so that every
 * word the product says lives in one place. Keys are namespaced by area, not by
 * screen, so text survives a component being moved or redesigned.
 */
export const defaultNS = "host";

void i18n.use(initReactI18next).init({
  lng: "en-GB",
  supportedLngs: ["en-GB"],
  fallbackLng: false,
  ns: [defaultNS],
  defaultNS,
  resources: { "en-GB": enGB },
  interpolation: { escapeValue: false },
});

/**
 * Missing keys fail loudly in development and degrade gracefully in production. A
 * customer must never see a raw key where a price or a confirmation should be.
 */
i18n.on("missingKey", (_lngs, ns, key) => {
  if (import.meta.env.DEV) {
    throw new Error(`[i18n] missing key ${ns}:${key}`);
  }
  console.error(`[i18n] missing key ${ns}:${key}`);
});

export default i18n;
